<template>
  <el-col :span="24" :style="{height: height}">
    <div :class="className" :style="{height:chartHeight,width:chartWidth}" @click="onClick" />
  </el-col>
</template>

<script>
  import echarts from 'echarts'
  require('echarts/theme/macarons') // echarts theme
  import {
    debounce
  } from '../utils/helper.js'
  import lodash from 'lodash'
  export default {
    props: {
      className: {
        type: String,
        default: 'chart'
      },
      width: {
        type: Number,
        default: 24
      },
      height: {
        type: String,
        default: '100%'
      },
      autoResize: {
        type: Boolean,
        default: true
      },
      show:{
              type:Boolean,
              default:true
            },
      // 图标配置
      chartConfig: {
        type: Object,
        default: function() {
          return {}
        }
      }
    },
    data() {
      return {
        timer: null,
        chart: null,
        sidebarElm: null,
        chartConfigModel: {},
        chartWidth: '100%',
        chartHeight: '100%',
        defaultConfig: {
          title: {
            text: null,
            left: 'center',
            show: true
          },
          xAxis: {
            data: [],
            boundaryGap: false,
            axisTick: {
              show: false
            },
            axisLabel: {
              interval: 0,
              rotate: 0,
            },
            //是否去掉网格线
            splitLine: {
              show: false
            },
            //是否显示网格区域
            splitArea: {
              show: false
            }
          },
          yAxis: {
            axisTick: {
              show: false
            },
            splitLine: {
              show: false
            },
            splitArea: {
              show: false
            } //保留网格区域
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '10%',
            top:'3%',
            containLabel: true
          },
          dataZoom: null,
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross'
            },
            padding: [5, 10]
          },

          legend: {
            data: [],
            left: 'center',
            top: 'bottom',
            padding: 5,
            show: false
          },
          series: [],
          animationEasing: 'linear',
          //数据更新动画的时长
          animationDurationUpdate: 500,
          //数据更新动画的延迟
          animationDelayUpdate: 500,
           //是否开启动画刷新
           isOpenPlayTimer: '1',
           //动画刷新检测
           playTimer: 10000,
        },
        animalConfig: {
          //数据更新动画的时长
          animationDurationUpdate: 500,
          //数据更新动画的延迟
          animationDelayUpdate: 500,
          //动画刷新检测
          playTimer: 10000,
          //是否开启动画刷新
          isOpenPlayTimer: '0'
        }

      }
    },
    computed: {
      widthHeight() {
        return {
          width: this.width,
          height: this.height
        }
      }
    },
    watch: {
      // 防止表格预置数据不成功，涉及生命周期问题
      chartConfig: {
        handler(newValue, oldValue) {
          this.chartConfigModel = lodash.cloneDeep(newValue)
          this.mergeConfig()
          this.setOptions(true)
        },
        deep: true
      },
      widthHeight: {
        handler(newValue, oldValue) {
          this.__resizeHandler()
        },
        deep: true
      },
      show:{
        handler(newValue,oldValue){
          this.__resizeHandler()
        },
        deep:true
      }
    },
    created() {

    },
    mounted() {
      this.chartConfigModel = lodash.cloneDeep(this.chartConfig)
      this.mergeConfig()
      this.initChart()
      this.setOptions(true)
      if (this.autoResize) {
        this.__resizeHandler = debounce(() => {
          if (this.chart) {
            this.chart.resize()
          }
        }, 100)
        window.addEventListener('resize', this.__resizeHandler)
      }

      // 监听侧边栏的变化
      this.sidebarElm = document.getElementsByClassName('sidebar-container')[0]
      this.sidebarElm && this.sidebarElm.addEventListener('transitionend', this.sidebarResizeHandler)

    },
    beforeDestroy() {
      this.closeTimer()
      if (!this.chart) {
        return
      }
      if (this.autoResize) {
        window.removeEventListener('resize', this.__resizeHandler)
      }

      this.sidebarElm && this.sidebarElm.removeEventListener('transitionend', this.sidebarResizeHandler)

      this.chart.dispose()
      this.chart = null
    },
    methods: {
      mergeConfig() {
        let that=this
        let _config = lodash.cloneDeep(this.defaultConfig)
        lodash.merge(_config, this.chartConfigModel)
        this.chartConfigModel = _config
        this.animalConfig.animationDurationUpdate = this.chartConfigModel.animationDurationUpdate
        this.animalConfig.animationDelayUpdate = this.chartConfigModel.animationDelayUpdate
        this.animalConfig.playTimer = this.chartConfigModel.playTimer
        this.animalConfig.isOpenPlayTimer = this.chartConfigModel.isOpenPlayTimer
        delete this.chartConfigModel.playTimer;
        delete this.chartConfigModel.isOpenPlayTimer;
        delete this.chartConfigModel.animationDurationUpdate;
        delete this.chartConfigModel.animationDelayUpdate;
        if (this.animalConfig.isOpenPlayTimer == '1') {
          this.chartConfigModel.animation = true

        } else {
          this.chartConfigModel.animation = false
        }
        if(that.chartConfigModel && that.chartConfigModel.series){
          for(let i=0;i<that.chartConfigModel.series.length;i++){
            that.chartConfigModel.series[i].animation=that.chartConfigModel.animation
            that.chartConfigModel.series[i].animationEasing='linear'
            that.chartConfigModel.series[i].animationDuration=1000
            // that.chartConfigModel.series[i].animationDelayUpdate=that.animationDelayUpdate
          }
        }
      },

      animationDurationUpdate(idx){
        if(idx){
          return (idx+1) * this.animalConfig.animationDurationUpdate;
        }else{
          return this.animalConfig.animationDurationUpdate;
        }
      },
      animationDelayUpdate(idx){
        if(idx){
          return (idx+0) * this.animalConfig.animationDelayUpdate;
        }else{
          return this.animalConfig.animationDelayUpdate;
        }

      },
      sidebarResizeHandler(e) {
        if (e.propertyName === 'width') {
          this.__resizeHandler()
        }
      },
      closeTimer() {
        if (!this.timer) {
          clearInterval(this.timer)
          this.timer = null
        }
      },
      createTimer() {
        let that = this
        if (!this.timers) {
          this.timers = setInterval(function() {
            that.setOptions(true)
          }, that.animalConfig.playTimer)
        }
      },
      setOptions(notMerge) {
        this.closeTimer()

        this.createTimer()
        this.chart.clear();
        this.chart.setOption(this.chartConfigModel, notMerge)
        this.chart.resize()
      },
      initChart() {
        this.chart = echarts.init(this.$el, 'macarons')
        this.setOptions(false)
      },
      onClick() {}

    }
  }
</script>



// WEBPACK FOOTER //
// src/components/LineChart.vue